import { $host } from "../http";

export const fetchAllCourses = async () => {
    try {
        const response = await $host.get('/api/public/courses');
        return response.data; // Возвращаем только данные
    } catch (error) {
        throw new Error(error.message || 'Ошибка при выполнении запроса');
    }
};

export const fetchAllCourseOptions = async () => {
    try {
        const response = await $host.get('/api/public/course-options');
        return response.data; // Возвращаем только данные
    } catch (error) {
        throw new Error(error.message || 'Ошибка при выполнении запроса');
    }
};